import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "contexts";
export const useActiveTournamentsCountsKey = "tournaments/active/count";
const useActiveTournamentsCount = () => {
  const { apiService } = useAppContext();
  return useQuery<number>({
    queryKey: [useActiveTournamentsCountsKey],
    queryFn: async () => {
      const response = await apiService.get<number>(`/tournaments/active/count`);
      return response;
    },
  });
};

export default useActiveTournamentsCount;
